import(/* webpackMode: "eager", webpackExports: ["Main"] */ "/codebuild/output/src2755445382/src/car-x-frontend/src/templates/Main.tsx");
